import { Box } from "@mui/material";
import React, { useState } from "react";
import RegisteredMembersList from "./RegisteredMembersList";
import { MembershipModel } from "model/screensModels/membership/MembershipModel";
import UpdateRegisteredMember from "./UpdateRegisteredMember";

export default function RegisteredMembers() {
  const [updateValue, setUpdateValue] = React.useState(new MembershipModel());
  const [flag, setFlag] = useState(false)
  
  //to get update record value
  const getUpdateRecordValue = (membershipModel: MembershipModel) => {
    setUpdateValue(membershipModel);
  }

return (
    <>
      <Box sx={{ width: '100%' }} className="container container-h-full">
        <Box>
          <div className='content-subheader'>
            <h2 className='font-weight-bolder'>Registered Member List</h2>
          </div>
        </Box>
          {!flag ?
            (<div className='sub-content-sec recently-blog'>
              <RegisteredMembersList setFlag={setFlag} updateRecord={getUpdateRecordValue}></RegisteredMembersList>
            </div>)
            :
            <>
                <div className='row'>
                  <div className='col-lg-12'>
                    <div>
                      <UpdateRegisteredMember setFlag={setFlag} updateRecord={updateValue}></UpdateRegisteredMember>
                    </div>
                  </div>
                </div>
            </>
          }
      </Box>
    </>
  );
}
